import { CheckCircleIcon, StarIcon } from "@heroicons/react/24/solid";
import { useState } from "react";

interface Task {
  id: number;
  description: string;
  claimed: boolean;
}

const TwitterGamePage = () => {
  const initialTasks: Task[] = [
    {
      id: 1,
      description: "Follow @sven on X (Twitter)",
      claimed: false,
    },
    {
      id: 2,
      description: "Add sven to your X name (Twitter)",
      claimed: false,
    },
    {
      id: 3,
      description: "Like & RT this post on X (Twitter)",
      claimed: false,
    },
    {
      id: 4,
      description: "Make a tweet about this on X (Twitter)",
      claimed: false,
    },
  ];

  const [tasks, setTasks] = useState<Task[]>(initialTasks);
  const [points, setPoints] = useState<number>(0);

  const handleClaim = (taskId: number) => {
    setTasks((prevTasks) =>
      prevTasks.map((task) =>
        task.id === taskId ? { ...task, claimed: true } : task
      )
    );
    setPoints((prevPoints) => prevPoints + 400); // Assuming each task gives 400 points
  };

  const isWinner = points >= 1000;

  return (
    <main className="py-10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          <div className="col lg:col-span-2">
            <figure>
              <h5 className="mb-4 font-semibold text-xl text-white">
                Available Tasks
              </h5>
              <ul className="space-y-5">
                <li>
                  <div className="bg-gray-900 rounded-[0.625rem] py-6 px-9">
                    <div className="flex flex-wrap items-center gap-4 mb-6">
                      <div className="flex items-center gap-3 mr-auto">
                        <img
                          className="rounded-full object-cover"
                          width={30}
                          height={30}
                          src="/assets/images/twitter-x-icon.png"
                          alt="..."
                        />
                        <h6 className="text-white font-semibold font-montserrat text-lg capitalize">
                          X (Twitter) Tasks
                        </h6>
                      </div>
                      <div className="flex items-center gap-1">
                        <span className="font-semibold text-xs">
                          ({tasks.filter((task) => task.claimed).length}/
                          {tasks.length}) Completed
                        </span>
                      </div>
                    </div>
                    <div className="list space-y-3">
                      {tasks.map((task) => (
                        <div
                          key={task.id}
                          className="bg-gray-800 py-3 px-6 rounded-[0.625rem]"
                        >
                          <div className="flex flex-wrap gap-3 items-center">
                            <div className="col mr-auto">
                              <span className="text-xs text-white font-semibold">
                                {task.description}
                              </span>
                              <div className="text-xs text-gray-400">
                                Get 400 Points
                              </div>
                            </div>
                            <div className="col">
                              {task.claimed ? (
                                <CheckCircleIcon className="text-green-600 h-10 w-10" />
                              ) : (
                                <button
                                  type="button"
                                  className="block group relative font-heading px-3 py-2 w-full capitalize text-white font-semibold tracking-px bg-gradient-to-bl from-primary to-primaryHover overflow-hidden rounded-md transition-transform duration-500 active:scale-105"
                                  onClick={() => handleClaim(task.id)}
                                >
                                  <div className="absolute top-0 left-0 transform -translate-x-full group-hover:-translate-x-0 h-full w-full transition ease-in-out duration-500 bg-primaryHover" />
                                  <span className="block relative z-10 text-xs">
                                    Claim
                                  </span>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </li>
              </ul>
              {/* <ul className="space-y-5">
                <li>
                  <div className="bg-gray-900  rounded-[0.625rem] py-6 px-9">
                    <div className="flex flex-wrap items-center gap-4 mb-6">
                      <div className="flex items-center gap-3 mr-auto">
                        <img
                          className="rounded-full object-cover"
                          width={30}
                          height={30}
                          src="/assets/images/twitter-x-icon.png"
                          alt="..."
                        />
                        <h6 className="text-white font-semibold font-montserrat text-lg capitalize">
                          X (Twitter) Tasks
                        </h6>
                      </div>
                      <div className="flex items-center gap-1">
                        <span className="font-semibold text-xs">
                          (0/4) Completed
                        </span>
                      </div>
                    </div>
                    <div className="list space-y-3">
                      <div className="bg-gray-800 py-3 px-6 rounded-[0.625rem]">
                        <div className="flex flex-wrap gap-3 items-center">
                          <div className="col mr-auto">
                            <span className="text-xs text-white font-semibold">
                              Follow
                              <span className="text-primary mx-1">
                                @sven
                              </span>
                              on X (Twitter)
                            </span>
                            <div className="text-xs text-gray-400">
                              Get 400 Points
                            </div>
                          </div>
                          <div className="col">
                            <CheckCircleIcon className="text-green-600 h-10 w-10" />
                          </div>
                        </div>
                      </div>
                      <div className="bg-gray-800 py-3 px-6 rounded-[0.625rem]">
                        <div className="flex flex-wrap gap-3 items-center">
                          <div className="col mr-auto">
                            <span className="text-xs text-white font-semibold">
                              Add
                              <span className="text-primary mx-1">
                                sven
                              </span>
                              to your X name (Twitter)
                            </span>
                            <div className="text-xs text-gray-400">
                              Get 400 Points
                            </div>
                          </div>
                          <div className="col">
                            <button
                              type="button"
                              className="block group relative font-heading px-3 py-2 w-full capitalize text-white font-semibold tracking-px bg-gradient-to-bl from-primary to-primaryHover overflow-hidden rounded-md transition-transform duration-500 active:scale-105"
                            >
                              <div className="absolute top-0 left-0 transform -translate-x-full group-hover:-translate-x-0 h-full w-full transition ease-in-out duration-500 bg-primaryHover" />
                              <span className="block relative z-10 text-xs">
                                Claim
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="bg-gray-800 py-3 px-6 rounded-[0.625rem]">
                        <div className="flex flex-wrap gap-3 items-center">
                          <div className="col mr-auto">
                            <span className="text-xs text-white font-semibold">
                              Like & RT
                              <a
                                href="https://twitter.com/ordzaar/status/1787122971582054570"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-primary mx-1"
                              >
                                this post
                              </a>
                              X (Twitter)
                            </span>
                            <div className="text-xs text-gray-400">
                              Get 400 Points
                            </div>
                          </div>
                          <div className="col">
                            <button
                              type="button"
                              className="block group relative font-heading px-3 py-2 w-full capitalize text-white font-semibold tracking-px bg-gradient-to-bl from-primary to-primaryHover overflow-hidden rounded-md transition-transform duration-500 active:scale-105"
                            >
                              <div className="absolute top-0 left-0 transform -translate-x-full group-hover:-translate-x-0 h-full w-full transition ease-in-out duration-500 bg-primaryHover" />
                              <span className="block relative z-10 text-xs">
                                Claim
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="bg-gray-800 py-3 px-6 rounded-[0.625rem]">
                        <div className="flex flex-wrap gap-3 items-center">
                          <div className="col mr-auto">
                            <span className="text-xs text-white font-semibold">
                              Make a tweet about
                              <a
                                href="https://x.com/intent/post?text=Bullish+on+builders%21+%F0%9F%9F%A7%0A%0A1.+%40Ordzaar+partners+w%2F%40OKXWeb3+to+launch+Ordinals+%26+Runes+WORLD+TOUR+events+driving+adoption%21%0A%0A2.+%40OdinSwap+an+AMM+RUNES+Swap+Coming+Soon%21%0A%0A3.+Ordzaar+Pass+now+INTEROPERABLE+with+%40unisat_wallet+%26+%40GeniiData+platforms%21"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-primary mx-1"
                              >
                                this
                              </a>
                              X (Twitter)
                            </span>
                            <div className="text-xs text-gray-400">
                              Get 400 Points
                            </div>
                          </div>
                          <div className="col">
                            <button
                              type="button"
                              className="block group relative font-heading px-3 py-2 w-full capitalize text-white font-semibold tracking-px bg-gradient-to-bl from-primary to-primaryHover overflow-hidden rounded-md transition-transform duration-500 active:scale-105"
                            >
                              <div className="absolute top-0 left-0 transform -translate-x-full group-hover:-translate-x-0 h-full w-full transition ease-in-out duration-500 bg-primaryHover" />
                              <span className="block relative z-10 text-xs">
                                Claim
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul> */}
              <div className="mt-10">
                <img
                  width={2000}
                  height={1000}
                  className="object-cover w-full max-h-[37.5rem] rounded-[0.625rem]"
                  src="/assets/images/banner-1.jpg"
                  alt="..."
                />
              </div>
            </figure>
          </div>
          <div className="col md:border-l md:border-[#6F6F6F] md:pl-6">
            <div className="sticky top-32">
              <div className="bg-gray-900 border border-[#373737] rounded-[0.625rem]">
                <div className="rounded-t-[0.625rem] bg-black text-white p-4 text-center">
                  <h6 className="text-lg font-montserrat font-semibold">
                    Campaign Rewards
                  </h6>
                </div>
                <div className="px-4 py-6 flex gap-3">
                  <h6 className="font-semibold text-base mr-auto">Rewards</h6>
                  <div className="flex flex-col items-end justify-end gap-3 xl:min-w-56">
                    <div className="py-2 px-3 rounded-lg bg-[#D8D8D81F] border border-[#373737] inline-flex items-center gap-2 transition-all duration-500 hover:-translate-y-1">
                      <span className="text-xs font-semibold">
                        {points} points
                      </span>
                      <span>
                        <StarIcon className="text-primary h-4 w-4" />
                      </span>
                    </div>
                    <h6 className="font-semibold text-xs">1000 Winners</h6>
                  </div>
                </div>
                <div className="px-4 pb-6 space-y-1 text-right">
                  <h6 className="font-semibold text-xs">
                    To the first 1000 participants!
                  </h6>
                  <h6 className="font-bold text-color text-sm">
                    {isWinner
                      ? "Congratulations! You are a Winner!"
                      : "Winner on 1000 Points"}
                  </h6>
                </div>
              </div>
              <h5 className="mt-4 mb-4 font-semibold text-xl text-white">
                Updated info
              </h5>
              <ul className="space-y-4">
                <li className="flex items-center gap-3 justify-between">
                  <span className="font-montserrat font-semibold text-base text-[#B4B4B4]">
                    Participants
                  </span>
                  <span className="font-montserrat text-sm">1</span>
                </li>
                <li className="flex items-center gap-3 justify-between">
                  <span className="font-montserrat font-semibold text-base text-white">
                    Winners
                  </span>
                  {/* Winner on 1000 Points */}
                  <span className="font-montserrat text-sm">0</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default TwitterGamePage;
